import { SegmentedControl } from '@/components/SegmentedControl'
import {
  SegmentedIndicator,
  segmentedOptionClassName,
} from '@/components/SegmentedIndicator'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import { modeLabel } from '@/lib/format'
import type { ModeSelectProps } from './ModeSelect.types'

const GATED_OPTION =
  'relative flex h-full items-center rounded-full px-3.5 font-medium whitespace-nowrap cursor-pointer text-muted-foreground opacity-60 hover:text-foreground focus-visible:outline-none focus-visible:ring-ring/50 focus-visible:ring-[3px]'

export function ModeSelect({ name, value, gate, onChange }: ModeSelectProps) {
  const directLabel = modeLabel('direct')
  const intentMapLabel = modeLabel('intent_map')
  const indicatorId = `${name}-active-indicator`

  return (
    <fieldset>
      <legend className="sr-only">Mode</legend>

      <SegmentedControl>
        <label className={segmentedOptionClassName(value === 'direct')}>
          {value === 'direct' && <SegmentedIndicator layoutId={indicatorId} />}
          <input
            type="radio"
            name={name}
            value="direct"
            checked={value === 'direct'}
            onChange={() => onChange('direct')}
            className="sr-only"
          />
          <span className="relative">{directLabel}</span>
        </label>

        {gate ? (
          <TooltipProvider delayDuration={150}>
            <Tooltip>
              <TooltipTrigger asChild>
                <label
                  tabIndex={0}
                  onClick={gate.onGatedClick}
                  onKeyDown={(e) => {
                    if (e.key !== 'Enter' && e.key !== ' ') return

                    e.preventDefault()
                    gate.onGatedClick()
                  }}
                  className={GATED_OPTION}
                >
                  <input
                    type="radio"
                    name={name}
                    value="intent_map"
                    disabled
                    className="sr-only"
                  />
                  {intentMapLabel}
                </label>
              </TooltipTrigger>
              <TooltipContent>{gate.tooltip}</TooltipContent>
            </Tooltip>
          </TooltipProvider>
        ) : (
          <label className={segmentedOptionClassName(value === 'intent_map')}>
            {value === 'intent_map' && (
              <SegmentedIndicator layoutId={indicatorId} />
            )}
            <input
              type="radio"
              name={name}
              value="intent_map"
              checked={value === 'intent_map'}
              onChange={() => onChange('intent_map')}
              className="sr-only"
            />
            <span className="relative">{intentMapLabel}</span>
          </label>
        )}
      </SegmentedControl>
    </fieldset>
  )
}
